import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0035251c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center mt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 col-sm-12 login-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Zaloguj się", -1))
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "Zapomniałem hasła", -1))
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_buttons = _resolveComponent("login-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.emailError }]),
            placeholder: "Email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
          }, null, 2), [
            [_vModelText, _ctx.email]
          ]),
          (_ctx.emailError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.emailError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.passwordError }]),
            placeholder: "Hasło",
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
          }, null, 2), [
            [_vModelText, _ctx.password]
          ]),
          (_ctx.passwordError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.passwordError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (_ctx.globalError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.globalError), 1))
            : _createCommentVNode("", true),
          (_ctx.isSending)
            ? (_openBlock(), _createBlock(_component_loading, { key: 1 }))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-gradient",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)))
              }, " Zaloguj się ")),
          _createVNode(_component_router_link, {
            class: "d-flex justify-content-end",
            to: { name: 'forgot-password' }
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_login_buttons, {
          "hide-login": "",
          "hide-reset-password": ""
        })
      ])
    ])
  ]))
}